import React, { useState } from 'react'
import { 
    useDispatch,
    useSelector
} from 'react-redux';
import { useNavigate } from 'react-router'
import {
    InfoWindow,
    OverlayView,
} from '@react-google-maps/api';
import { Input, Badge, message, Tooltip } from 'antd';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// Constans
import { 
    TEMPLATE,
    ROUTES
} from '../../../../constants'

// Components
// import EventStatusIcon from "../../../EventStatusIcon"
import VehiclePlateECUTag from '../../../VehiclePlateECUTag'
import GeoAddress from '../../../GeoAddress'

// Handlers
import {
    vehicles_handler,
    report_handler
} from '../../../../handlers'

// Services
import { RoundUp, TIME } from '../../../../services/util';

// Redux Actions
import {
    v3_mapControl,
    v3_devices,
    v3_liveCamera,
    v3_vehicles
} from '../../../../services/redux/actions'
import SVG from '../../../SVG';
import ModalStandard from '../../../ModalStandard';
import ModalIntercom from '../ModalIntercom';

const {
    VEHICLE_TRANSIT_STATUS_OBJECT,
    VEHICLE_TRANSIT_STATUS_COLOR,
    // driverScoreIndicator
} = TEMPLATE.STATUS

const {
    showVehicleStateLastUpdated_DateTime,
    showVehicleTransitStatusChangeDuration 
} = vehicles_handler

const {
    DERIVATIVE_DATA_TYPE,
    MILEAGE_TYPE,
    speedSelector,
    mileageSelector
} = report_handler

const {
    set_new_geofence_from_map,
    remove_enabled_vehicle_pop_up
} = v3_mapControl

const {
    update_device_buzzer_action_request
} = v3_devices

const {
    set_selected_live_camera_by_vid_request
} = v3_liveCamera

const { 
    set_selected_vehicle_request
} = v3_vehicles

const VehicleInformationBox = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const mapControl = useSelector(state => state.containers.v3.mapControl);
    const vehicles = useSelector(state => state.containers.v3.vehicles)
    const driver = useSelector(state => state.containers.v3.drivers.byID)
    const devicesMDVR = useSelector(state => state.containers.v3.devicesMDVR)
    // const vehicleFuelInfo = useSelector(state => state.containers.v3.vehicles.fuelProfileByID)
    
    const {
        thisVehicle,
        thisVehicleStatic,
        paddingInt
    } = props

    const vehicleFuel = vehicles.fuelProfileByID[thisVehicle.vid]
    const deviceMDVR = (devicesMDVR.byID[thisVehicleStatic.mdvrid] || devicesMDVR.stateByID[thisVehicleStatic.mdvrid]) && { 
        ...devicesMDVR.byID[thisVehicleStatic.mdvrid], 
        ...devicesMDVR.stateByID[thisVehicleStatic.mdvrid] 
    }

    // const tankCapacities = vehicleFuel && Array.from({ length: tankNum.length }).map((_, i) => {

    //     const operator = vehicleFuel[`${i}_operator`] 
        
    //     return `${vehicleFuel[`${i}_capacity`] || 0} ${operator === 'V' ? 'L' : operator}`
    // });

    const [ remark, setRemark ] = useState('')

    const score = driver[thisVehicleStatic.drvid]?.score
    const scoreSub = driver[thisVehicleStatic.sub_drvid]?.score
    const address = thisVehicle.address

    const fuelProfile = []

    const vhcFuelProfile = vehicleFuel || {}
    const fuel_tankNum = vehicleFuel?.tankNum || 0
    const VHCDs = vehicles.derivativeStateByID[thisVehicle.vid]

    for(let n = 0; n < fuel_tankNum; n++) {
        const vehicleLevel = (VHCDs && vhcFuelProfile && VHCDs[vhcFuelProfile[`${n}_deviceParam`]]) || 0
        const vfMax = (vhcFuelProfile && vhcFuelProfile [`${n}_max`]) || 0
        const vfMin = (vhcFuelProfile && vhcFuelProfile [`${n}_min`]) || 0
        const fuelLevel = Number((((vehicleLevel-vfMin) / (vfMax-vfMin)) * 100).toFixed(2))

        const fuelPercentage = isFinite(fuelLevel) ? fuelLevel : 0

        let fuelCapacity = null

        switch(vhcFuelProfile [`${n}_operator`]) {
            case 'L': {
                const temp = vehicleLevel?.toFixed(2)
                fuelCapacity = `Fuel Tank ${n+1}: ${isFinite(temp) ? temp : 0}L`
                break;
            }
            case 'V':
            case '%': {
                const temp = (fuelLevel / 100) * vhcFuelProfile [`${n}_capacity`] || 0
                fuelCapacity = `Fuel Tank ${n+1}: ${fuelPercentage}% (${isFinite(temp) ? temp.toFixed(2) : 0}L)`
                break;
            }
            // case 'V': {
            //     const temp = vehicleLevel?.toFixed(2)
            //     fuelCapacity = `Fuel Tank ${n+1}: ${isFinite(temp) ? temp : 0}V`
            //     break;
            // }
            default: 
                break;
        }

        fuelProfile.push(fuelCapacity)
    }

    return (
        <InfoWindow
            zIndex = {1000}
            options = {{ disableAutoPan: true }}
            mapPaneName = {OverlayView.OVERLAY_MOUSE_TARGET}
            position = {{
                lat: parseFloat(thisVehicle.location.lat),
                lng: parseFloat(thisVehicle.location.lon)
            }}
            onCloseClick = {() => {
                dispatch(remove_enabled_vehicle_pop_up(thisVehicle.vid));
            }}
        >
            <div 
                style = {{ 
                    width: 330 + paddingInt,
                    padding: paddingInt,
                }}
            >
                <h2>
                    <VehiclePlateECUTag
                        // plate={thisVehicleStatic.displayName}
                        plate={thisVehicleStatic.plate}
                        vehicle={thisVehicle}
                    />
                    &ensp;
                    {
                        thisVehicle.do_1 ?
                        <ModalStandard 
                            onClick={() => dispatch(update_device_buzzer_action_request({
                                dvid: thisVehicleStatic.dvid,
                                action: 0,
                                duration: 5,
                                remark
                            }))}
                            title={'Deactivate the buzzer'}
                            content={'You are about to deactivate the buzzer remotely. Select Yes to confirm your choice.'}
                            subcontent={<Input.TextArea style={{ height: 150, resize: 'none' }} onChange={(e) => setRemark(e.target.value)}/>}
                            icon={
                                <SVG 
                                    name={`warning-blue`}
                                    viewBox="0 0 35 35" 
                                    fill="none" 
                                    size="50"
                                />
                            }
                        >
                            <SVG 
                                viewBox="0 0 16 16" 
                                fill="none" 
                                size="20"
                                name={`buzz-on`}
                            />
                        </ModalStandard>
                        :
                        <ModalStandard 
                            onClick={() => dispatch(update_device_buzzer_action_request({
                                dvid: thisVehicleStatic.dvid,
                                action: 1,
                                duration: 3,
                                remark
                            }))}
                            title={'Activate the buzzer'}
                            content={'You are about to activate the buzzer remotely. Once activated, the buzzer will be active for 5 seconds. Please input a remark and confirm your choice.'}
                            subcontent={<Input.TextArea style={{ height: 150, resize: 'none' }} onChange={(e) => setRemark(e.target.value)}/>}
                            icon={
                                <SVG 
                                    name={`warning-blue`}
                                    viewBox="0 0 35 35" 
                                    fill="none" 
                                    size="50"
                                />
                            }
                        >
                            <SVG 
                                viewBox="0 0 16 16" 
                                fill="none" 
                                size="20"
                                name={`buzz-off`}
                            />
                        </ModalStandard>
                    }
                    &thinsp;
                    {
                        deviceMDVR
                        &&
                        <ModalIntercom mdvrid={thisVehicleStatic.mdvrid} deviceMDVR={deviceMDVR} />
                    }
                </h2>

                <p
                    style = {{
                        color: thisVehicle.transitStatus ?  VEHICLE_TRANSIT_STATUS_COLOR[thisVehicle.transitStatus] :  VEHICLE_TRANSIT_STATUS_COLOR["NULL"]
                    }}
                >
                    {
                        showVehicleTransitStatusChangeDuration(thisVehicle)
                    }
                </p> 

                <p>Coordinates: 
                    <span 
                        aria-hidden='true' className="ButtonLink" 
                        onClick = {() => window.open(`https://www.google.com.my/maps/place/${thisVehicle.location.lat},${thisVehicle.location.lon}`, "_blank")}>
                        {thisVehicle.location.lat}, {thisVehicle.location.lon}
                    </span>
                    <Tooltip
                        placement="top" 
                        title={'Show Live Street view'}
                    >
                        <span
                            aria-hidden='true' className="ButtonLink" 
                            onClick = {() => window.open(`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${thisVehicle.location.lat},${thisVehicle.location.lon}`, "_blank")}
                        >
                            📍
                        </span>
                    </Tooltip>
                </p>
                {<p>Speed: {`${thisVehicle.transitStatus === VEHICLE_TRANSIT_STATUS_OBJECT.MOVING ? ( speedSelector(thisVehicle, DERIVATIVE_DATA_TYPE.STATE).toFixed(1) ) || '0.0' : "0.0"} km/h`}</p>}
                {<p>Odometer: {mileageSelector(thisVehicle, MILEAGE_TYPE.ODOMETER, 0, true, false)}</p>}
                {
                    fuelProfile.length && fuelProfile.map((tank, i) => <p key={i}>{tank}</p>) || ''
                }
                {<p>Engine Hours: {RoundUp(TIME.parseHours(thisVehicle.plat_hist_engine_hour || 0), 0)?.toLocaleString('en-US')} hrs</p>}
                {/* {<p>Historical Mileage: {`${mileageSelector(thisVehicle, MILEAGE_TYPE.ODOMETER).toFixed(0)} km`}</p>} */}
                {
                    (thisVehicle.transitStatus !== 'PARKING') && thisVehicleStatic.drvid &&
                    <p>Driver: 
                        {
                            driver[thisVehicleStatic.drvid]?.contact
                            &&
                            <span
                                aria-hidden="true"
                                className="ButtonLink" 
                                onClick={() => window.open(`https://wa.me/${driver[thisVehicleStatic.drvid]?.contact?.replace(/\D/g, '')}`, '_blank')}
                                style={{ cursor: 'pointer' }}
                            >
                            <span> {driver[thisVehicleStatic.drvid]?.name || thisVehicleStatic.drvid || ' - ' } ({driver[thisVehicleStatic.drvid]?.contact}) { score && `(${score?.toFixed(2)}%)` || null }</span>
                                <WhatsAppIcon style={{ height: '15px'}}/>
                            </span>
                            ||
                            '-'
                        }
                    </p>
                }

                {
                    (thisVehicleStatic.sub_drvid && (thisVehicleStatic.sub_drvid !== '-') && (thisVehicle.transitStatus !== 'PARKING'))
                    &&
                    <p>Driver (S): <span> {driver[thisVehicleStatic.sub_drvid]?.name || thisVehicleStatic.sub_drvid || ' - ' } { scoreSub && `(${scoreSub?.toFixed(2)}%)` || null }</span>
                    </p>

                }
                <p>
                    {showVehicleStateLastUpdated_DateTime(thisVehicle)}
                </p>
                {
                    thisVehicleStatic.mdvrid && (thisVehicleStatic.mdvrid !== '-')
                    &&
                    <>
                        <p>MDVR Status: 
                            {
                                <>
                                    <Badge color={deviceMDVR.IsOnline ? 'green' : 'red'} style={{ margin: '0 7px'}} />
                                    <span>{deviceMDVR.IsOnline ? 'Online' : 'Offline'}</span>
                                </>
                            }
                        </p>
                        <p>
                            Last Online: {TIME.getUTCToMalay(deviceMDVR.OffLineTime) || '-'}
                        </p>
                    </>
                }

                {
                    thisVehicle.transitStatus !== VEHICLE_TRANSIT_STATUS_OBJECT.DISCONNECTED &&
                        <div style = {{ marginBottom: 5 }}>
                            <GeoAddress 
                                vid={thisVehicle.vid}
                                keyIndex={0}
                            />
                        </div>
                }

                <br />

                {/* <div
                    style = {{
                        display: "flex",
                        marginBottom: 5,
                    }}
                >
                    <EventStatusIcon vehicleID = {thisVehicle.vid}/>
                </div> */}

                <div
                    style = {{
                        display: "flex",

                        alignItems: "center",
                        // justifyContent: "center",
                        justifyContent: "space-between",

                        width: "100%",
                    }}
                >
                    <span
                        className = "ButtonLink"
                        aria-hidden="true"
                        onClick = {() => {
                            const currCoor = {
                                lat: parseFloat(thisVehicle.location.lat),
                                lng: parseFloat(thisVehicle.location.lon)
                            }

                            dispatch(set_new_geofence_from_map({
                                ...mapControl.geofence,
                                coordinates: [currCoor],
                                radius: 100,
                                name: address?.split(',')[0]
                            }));

                            navigate(ROUTES.MODULE_ROUTE.GEOFENCE_MANAGEMENT_POI_CREATE, { 'name':  address?.split(',')[0]});
                        }}
                        // style = {{
                        //     flex: 1,
                        //     fontSize: 12,
                        // }}
                    >
                        Add as POI
                    </span>

                    <span
                        className = "ButtonLink"
                        aria-hidden="true"
                        onClick = {() => {
                            dispatch(set_selected_vehicle_request(thisVehicleStatic.vid));

                            navigate(ROUTES.MODULE_ROUTE.VEHICLE_ROUTE_PLAYBACK);
                        }}
                        // style = {{
                        //     flex: 1,
                        //     fontSize: 12,
                        // }}
                    >
                        View Playback
                    </span>

                    <span
                        aria-hidden='true'
                        className = "ButtonLink"
                        onClick = {() => {
                            dispatch(remove_enabled_vehicle_pop_up(thisVehicle.vid));

                            if(!deviceMDVR?.IsOnline) {
                                message.warning('We are unable to retrieve playback. MDVR is currently offline.')
                            }
                            else if(thisVehicleStatic.mdvrid && deviceMDVR?.IsOnline) {
                                dispatch(set_selected_live_camera_by_vid_request(thisVehicle.vid, thisVehicleStatic.mdvrid, true))
                            }
                            else {
                                message.error('Playback unsuccessful. Vehicle is not assigned with MDVR')
                            }
                        }}
                    >
                        View Live Camera
                    </span>
                </div>
            </div>
        </InfoWindow>
    )
}

export default React.memo(VehicleInformationBox)